import React from "react";
import DirectExchange from "./directExchange";
import DirectExchangeUsdtUsdv from "./directExchangeUsdtUsdv";

const DirectExchangeCombined: React.FC = () => (
  <div>
    {/* <DirectExchange index={0} /> */}
    <div className="my-8" /> {/* Spacer */}
    <DirectExchangeUsdtUsdv index={2} />
  </div>
);

export default DirectExchangeCombined;
